import React from 'react'

import { useDispatch } from 'react-redux'

import {
  HowGoustoFoodBoxesWorkPage,
  HowGoustoFoodBoxesWorkCmsPage,
  MealPlanningPage,
  MealPlanningCmsPage,
  FoodBoxPage,
  FoodBoxCmsPage,
} from '@features/marketing-pages'
import {
  fetchCmsBlocks,
  FOOD_BOX_PAGE,
  HOW_GOUSTO_WORKS_PAGE,
  useIsHowGoustoWorksCmsEnabled,
  MEAL_PLANNING_PAGE,
  useIsCmsBlocksEnabled,
  useIsMealPlanningCmsEnabled,
} from '@library/cms-blocks'
import { fetchByUrl } from '@library/contentstack-client'

import { applyPromoCode } from 'actions/home'
import { redirect } from 'actions/redirect'
import { fetchCmsEntry } from 'apis/cms'

export function HowGoustoWorks() {
  const dispatch = useDispatch()
  const isHowGoustoWorksCmsEnabled = useIsHowGoustoWorksCmsEnabled()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  // The Static page is the control/default. The Optimizely treatment renders the CMS page.
  return isHowGoustoWorksCmsEnabled ? (
    <HowGoustoFoodBoxesWorkCmsPage startOnboarding={handleClick} cmsFetcher={fetchCmsEntry} />
  ) : (
    <HowGoustoFoodBoxesWorkPage startOnboarding={handleClick} />
  )
}

// SSR: pre-populate Redux for /food-box/how-it-works on every request, regardless of
// flag state. The flag only controls which UI variant renders; CMS data is always
// fetched server-side to avoid a content flash when the flag flips on.
HowGoustoWorks.fetchData = ({ store }: { store: { dispatch: (action: unknown) => unknown } }) =>
  store.dispatch(fetchCmsBlocks([HOW_GOUSTO_WORKS_PAGE], fetchByUrl))

export function MealPlanning() {
  const dispatch = useDispatch()
  const isMealPlanningCmsEnabled = useIsMealPlanningCmsEnabled()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  // Inverted from FoodBox: the Optimizely treatment renders the new CMS page;
  // the default/control renders the existing static page.
  return isMealPlanningCmsEnabled ? (
    <MealPlanningCmsPage startOnboarding={handleClick} cmsFetcher={fetchCmsEntry} />
  ) : (
    <MealPlanningPage startOnboarding={handleClick} />
  )
}

// SSR: pre-populate Redux for /food-box/gousto-menu-and-plans on every request,
// regardless of flag state. The flag only controls which UI variant renders; CMS data
// is always fetched server-side to avoid a content flash when the flag flips on.
MealPlanning.fetchData = ({ store }: { store: { dispatch: (action: unknown) => unknown } }) =>
  store.dispatch(fetchCmsBlocks([MEAL_PLANNING_PAGE], fetchByUrl))

export function FoodBox() {
  const dispatch = useDispatch()
  const shouldRenderStaticFoodBoxPage = useIsCmsBlocksEnabled()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  // The CMS page is the control/default. The Optimizely treatment renders the previous static page.
  return shouldRenderStaticFoodBoxPage ? (
    <FoodBoxPage startOnboarding={handleClick} />
  ) : (
    <FoodBoxCmsPage startOnboarding={handleClick} cmsFetcher={fetchCmsEntry} />
  )
}

// SSR: pre-populate Redux for /food-box on every request, regardless of flag state.
// The flag only controls which UI variant renders; CMS data is always fetched server-side
// to avoid a content flash when the flag flips on.
FoodBox.fetchData = ({ store }: { store: { dispatch: (action: unknown) => unknown } }) =>
  store.dispatch(fetchCmsBlocks([FOOD_BOX_PAGE], fetchByUrl))
